import { makeVar } from '@apollo/client'
import { Maybe, User } from '__generated__/graphql'

export const globalLoaderVar = makeVar<boolean>(true)
export const userVar = makeVar<Maybe<User>>(null)
